import React, { memo, useRef } from "react";
// import component
import FormikContainer from "../../components/Formik/FormikContainer";
import DButton from "../../components/DButton";
import FieldContainer from "../../components/Formik/FieldContainer";
import { ErrorMessage, Form } from "formik";
import DCard from "../../components/DCard";
import { Spinner } from "@chakra-ui/react";
import DImage from "../DImage";
import ErrorMsg from "../Formik/Fields/ErrorMsg";
const CategoryForm = ({
    onSubmit,
    initialValues,
    validationSchema,
    btnText,
}) => {
    const fileRef = useRef();
    const setImageHandler = value => {
        if (typeof value === "object") {
            return URL.createObjectURL(value);
        }
        return value;
    };
    const deleteImageHandler = setFieldValue => {
        fileRef.current.value = "";
        setFieldValue("img", "");
    };
    return (
        <DCard>
            <FormikContainer
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({ values, isSubmitting, setFieldValue }) => (
                    <Form>
                        <div>
                            <div className="mb-4 text-center">
                                <label className="block mb-2" htmlFor="img">
                                    صورة المنتج:
                                </label>
                                <FieldContainer
                                    fileRef={fileRef}
                                    name="img"
                                    type="file"
                                    accept="image/*"
                                    id="img"
                                    hidden
                                />
                                {values.img && (
                                    <>
                                        <div className="mb-4 relative sm:w-[250px] h-[250px] border border-light-color rounded-sm mx-auto">
                                            <DImage
                                                className="w-full h-full object-contain"
                                                src={setImageHandler(
                                                    values.img
                                                )}
                                                alt={"category-image"}
                                                load={true}
                                            />
                                        </div>
                                        <DButton
                                            onClick={() =>
                                                deleteImageHandler(
                                                    setFieldValue
                                                )
                                            }
                                            className="text-white"
                                            bgColor="danger"
                                        >
                                            حذف الصورة
                                        </DButton>
                                    </>
                                )}
                                <DButton
                                    bgColor="secondry"
                                    onClick={() => fileRef.current?.click()}
                                >
                                    تحميل صورة
                                </DButton>
                                <div className="block">
                                    <ErrorMessage
                                        name="img"
                                        component={ErrorMsg}
                                    />
                                </div>
                            </div>
                            <div className="grid sm:grid-cols-2 gap-4">
                                <FieldContainer
                                    name="name_ar"
                                    type="text"
                                    label="الاسم بالعربية"
                                    id="name_ar"
                                />
                                <FieldContainer
                                    name="name_en"
                                    type="text"
                                    label="الاسم بالانجليزية"
                                    id="name_en"
                                />
                            </div>
                        </div>
                        <DButton
                            disabled={isSubmitting}
                            type="submit"
                            className="mx-auto min-w-[150px] rounded-lg  flex items-center justify-center text-white"
                        >
                            {isSubmitting ? <Spinner /> : btnText}
                        </DButton>
                    </Form>
                )}
            </FormikContainer>
        </DCard>
    );
};

export default memo(CategoryForm);
